import React from 'react'
import {sendEvent} from "../config/analytics"

const PriceVatToggle = ({showPricesInclVat, onChange}) => {
    const handleToggle = (nextShowPricesInclVat) => {
        if (nextShowPricesInclVat === showPricesInclVat) return
        sendEvent("price_vat_toggle", {
            show_prices_incl_vat: nextShowPricesInclVat,
        })
        onChange?.(nextShowPricesInclVat)
    }

    return (
        <div className="front-location-price-toggle">
            <span className="front-location-price-toggle__label">Tarieven</span>
            <div className="front-location-price-toggle__actions">
                <button
                    type="button"
                    className={`front-location-price-toggle__button ${showPricesInclVat ? 'is-active' : ''}`}
                    onClick={() => handleToggle(true)}
                >
                    Incl. btw
                </button>
                <button
                    type="button"
                    className={`front-location-price-toggle__button ${!showPricesInclVat ? 'is-active' : ''}`}
                    onClick={() => handleToggle(false)}
                >
                    Excl. btw
                </button>
            </div>
        </div>
    )
}

export default PriceVatToggle
